/** @jsx jsx */

import * as React from "react";
import { Nav } from "./TopNav";
import { IAppState } from "../models/IAppState"
import { connect } from "react-redux";
import IDoctorProfile, { IAgentAttributeResponse } from "../models/IDoctorProfile";
import AssetProvider from "../utils/AssetProvider";
import AppUtils from "../utils/AppUtils";
import { isEmpty } from "lodash";
import { slugMobile } from "../styles/slug/mobile/slug";
import { css, jsx } from "@emotion/core"
import { toastNotificationAppearance } from "../utils/AppConstants";

interface MobileMenuProps {
  navs: Nav[],
}

interface MobileMenuStateProps {
  doctorProfile: IDoctorProfile,
}

const navImgMap: any = {
  calendar: "/images/icons/calendar.svg",
  patients: "/images/icons/patient-nav.svg",
  roster: "/images/icons/working-hours-nav.svg",
  consultations: "/images/icons/consultations-nav.svg",
  logout: "/images/icons/logout.svg"
}

const DISABLED_NAV_IDS: string[] = [
  //  "treatmentPlans"
];
const copySlug = (slugValue: string) => {
  AppUtils.copyTextToClipboard(slugValue)
    .then(() => {
      AppUtils.triggerToastNotification("Copied !", toastNotificationAppearance.success);
    })
    .catch(console.log);
}
const MobileMenu: React.SFC<MobileMenuProps> = (props: MobileMenuProps & MobileMenuStateProps) => {
  const { doctorProfile } = props;
  const slugValue: string = AppUtils.getSlugUrl(doctorProfile);
  const [menuStatus, setMenuStatus] = React.useState(false)

  const toggleMobileMenu = () => {
        setMenuStatus(!menuStatus)
    }

  return (
    <main className={"mobile-menu-container"}>
      <img className={`mobile-menu-icon ${menuStatus ? "hide": ""}`} src={"/images/icons/menu.svg"} onClick={toggleMobileMenu} />
      <div className={`mobile-menu ${menuStatus ? "active" : ""}`}>
        <section className="mobile-navs-header">
          <img src="/images/icons/back-white.svg" onClick={toggleMobileMenu} />
          <div className="mobile-doctor-info">
            <img className="mobile-doctor-img" src={AssetProvider.getDoctorImage(props.doctorProfile)} />
            <div>
              <div className="mobile-doctor-title">{doctorProfile.prefix} {doctorProfile.name}</div>
              <div className="mobile-doctor-subtitle">{doctorProfile.detailedQualification}</div>
              {doctorProfile.registrationNumber && <div className="mobile-doctor-details">REGN. No : {doctorProfile.registrationNumber}</div>}
              {AppUtils.isDefined(doctorProfile.experience) && <div className="mobile-doctor-details">Experience: {doctorProfile.experience} years</div>}
              <div className="mobile-doctor-details">LINK : {slugValue}
                <img src="/images/copy-icon.png" alt="copy slug" css={slugMobile.copyIcon}
                  onClick={() => copySlug(slugValue)} />
              </div>
            </div>
          </div>
        </section>
        <div className="mobile-doctor-contact">
          <div className="mobile-doctor-contact-row">
            <span className="mobile-doctor-contact-label">Mobile No : </span>
            <span>{doctorProfile.phoneNumber}</span>
          </div>
          <div className="mobile-doctor-contact-row">
            <span className="mobile-doctor-contact-label">Email Id : </span>
            <span>{doctorProfile.emailId}</span>
          </div>
        </div>
        <section className="mobile-nav-urls">
          {props.navs.filter(nav => !DISABLED_NAV_IDS.includes(nav.id)).map((nav) => {
            return (
              <a key={nav.id} className="mobile-nav-row" href={nav.url}>
                <div>
                  {nav.label}
                </div>
                <img src={navImgMap[nav.id]} />
              </a>
            );
          })}
          <div className="mobile-nav-row" onClick={AppUtils.logout}>
            <div>
              Logout
            </div>
            <img src={navImgMap.logout} />
          </div>
        </section>
      </div>
      <div className={`hamburger-bg ${menuStatus ? "show" : ""}`} onClick={toggleMobileMenu} />
    </main>
  )
}

const mapStateToProps = (state: IAppState): any => {
  return {
    doctorProfile: state.doctorProfile,
  }
}

export default connect<MobileMenuStateProps, null, MobileMenuProps>(mapStateToProps)(MobileMenu);